import { ComponentProps } from 'react'
import './styles.css'

export const Skeleton = ({ className, ...props }: ComponentProps<'div'>) => {
  return <div data-slot="skeleton" className={`bpSkeleton ${className || ''}`} {...props} />
}

Skeleton.displayName = 'Skeleton'
